var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { Getter, State } from "vuex-class";
import AddCaseRemark from "~/components/collection-execution/operate-components/add-case-remark.vue";
import { SynthesizeQueryService } from "~/services/domain-service/synthesize-query.service";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TurnRecord from "~/components/synthesize-query-manage/case-info-query/turn-record.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
import { MENU_CHANNEL } from "../../config/enum.config";
var CaseInfoQuery = /** @class */ (function (_super) {
    __extends(CaseInfoQuery, _super);
    function CaseInfoQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.selectionList = [];
        _this.caseCollectionStatus = [];
        _this.submitLoading = false;
        _this.syncLoading = false;
        _this.dialog = {
            addCaseRemark: false,
            turnRecord: false // 流转记录
        };
        _this.caseId = "";
        _this.caseNumber = "";
        _this.model = {
            caseNumber: '',
            batchNumber: '',
            principalId: '',
            personalName: '',
            idCard: "",
            loanDate: [],
            mobileNo: '',
            partnerName: '',
            bankName: '',
            deptId: '',
            currentCollectorRealName: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            leaveCaseFlag: '',
            leaveDueDate: [],
            telAssistflag: '',
            assistFlag: '',
            legalAssistFlag: '',
            riskFlag: '',
            overduePeriod: '',
            loanAmount: { min: '', max: '' },
            loanPeriod: { min: '', max: '' },
            overdueDays: { min: '', max: '' },
            overdueAmount: { min: '', max: '' },
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            collectionType: '',
            collectionStatus: '',
            compensationMoney: {
                max: "",
                min: ""
            },
        };
        return _this;
    }
    Object.defineProperty(CaseInfoQuery.prototype, "departmentType", {
        //过滤催收类型
        get: function () {
            // 要过滤的字段
            var departmentTypes = ["TEL", "VISIT", "LEGAL"];
            return this.$dict.getDictData('DepartmentType').filter(function (v) { return departmentTypes.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaseInfoQuery.prototype, "collectionStatus", {
        //过滤催收状态
        get: function () {
            // 要过滤的字段
            var collectionStatus = ["INNER_WAIT_DISTRIBUTE", "INNER_COLLECTING", "INNER_BANKC", "INNER_PAYOFF", "INNER_RETURN", "INNER_PAUSE"];
            return this.$dict.getDictData('CollectionStatus').filter(function (v) { return collectionStatus.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    CaseInfoQuery.prototype.mounted = function () {
        this.refreshData();
    };
    CaseInfoQuery.prototype.caseTypeChange = function () {
        var _this = this;
        if (!this.model.caseType) {
            this.caseCollectionStatus = [];
            return (this.model.collectionStatus = "");
        }
        this.model.collectionStatus = "";
        this.synthesizeQuerService
            .getCaseCollectionStatus(this.model.caseType)
            .subscribe(function (data) { return (_this.caseCollectionStatus = data); });
    };
    CaseInfoQuery.prototype.refreshData = function () {
        var _this = this;
        this.synthesizeQuerService
            .caseSearch(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    CaseInfoQuery.prototype.departemntChange = function (id, code) { };
    CaseInfoQuery.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.loanPeriodMax = this.model.loanPeriod ? this.model.loanPeriod.max : "";
        params.loanPeriodMin = this.model.loanPeriod ? this.model.loanPeriod.min : "";
        params.overdueDaysMax = this.model.overdueDays ? this.model.overdueDays.max : "";
        params.overdueDaysMin = this.model.overdueDays ? this.model.overdueDays.min : "";
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime && this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime && this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.leaveDueDateMin = this.$filter.dateRanageFormat(this.model.leaveDueDate).start;
        params.leaveDueDateMax = this.$filter.dateRanageFormat(this.model.leaveDueDate).end;
        params.loanAmountMax = this.model.loanAmount ? this.model.loanAmount.max : "";
        params.loanAmountMin = this.model.loanAmount ? this.model.loanAmount.min : "";
        params.compensationMoneyMax = this.model.compensationMoney ? this.model.compensationMoney.max : "";
        params.compensationMoneyMin = this.model.compensationMoney ? this.model.compensationMoney.min : "";
        delete params.leaveDueDate;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.loanPeriod;
        delete params.overdueDays;
        delete params.loanAmount;
        delete params.compensationMoney;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    CaseInfoQuery.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.overdueDays = { min: "", max: "" };
        this.model.loanPeriod = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: "", max: "" };
        this.model.personalCollectionRemainingDays = { min: "", max: "" };
        this.model.compensationMoney = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    CaseInfoQuery.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Query_case_query,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 导出案件
     */
    CaseInfoQuery.prototype.exportCaseInfo = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.paramsHandler()), { caseIds: ids });
        this.synthesizeQuerService
            .caseSearchExportCase(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    CaseInfoQuery.prototype.handleSyncAnjian = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.paramsHandler()), { caseIds: ids });
        this.syncLoading = true;
        this.synthesizeQuerService.syncCollectionTypeToEs(request).subscribe(function (data) {
            _this.syncLoading = false;
            console.log("[case-info-query#:441]:", "refresh data");
            _this.refreshData();
        }, this.error);
    };
    /**
     * 导出催记
     */
    CaseInfoQuery.prototype.exportFollowup = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.caseId; });
        var request = __assign(__assign({}, this.paramsHandler()), { caseIds: ids });
        this.submitLoading = true;
        this.synthesizeQuerService
            .caseSearchExportFollow(request)
            .subscribe(function (data) {
            _this.$common.downloadFile(data.url);
            _this.submitLoading = false;
        }, this.error);
    };
    /**
     * 失败
     */
    CaseInfoQuery.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 导出录音
     */
    CaseInfoQuery.prototype.exportvideo = function () {
        this.$message.warning("暂无录音文件！");
    };
    CaseInfoQuery.prototype.onViewTurnRecord = function (row) {
        this.caseNumber = row.caseNumber;
        this.dialog.turnRecord = true;
    };
    __decorate([
        Dependencies(PageService)
    ], CaseInfoQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CaseInfoQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SynthesizeQueryService)
    ], CaseInfoQuery.prototype, "synthesizeQuerService", void 0);
    __decorate([
        Getter
    ], CaseInfoQuery.prototype, "departmentData", void 0);
    __decorate([
        State
    ], CaseInfoQuery.prototype, "principalList", void 0);
    CaseInfoQuery = __decorate([
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                AddCaseRemark: AddCaseRemark,
                TurnRecord: TurnRecord,
                SelectDepartment: SelectDepartment
            }
        })
    ], CaseInfoQuery);
    return CaseInfoQuery;
}(Vue));
export default CaseInfoQuery;
